// features/drive/components/Upload/UploadDropdown.js

import React from 'react';

import { Dropdown, Item } from './UploadDropdown.styles';

const UploadDropdown = ({ onUploadFiles, onUploadFolder, onClose }) => {
  const handleFiles = () => {
    onUploadFiles?.();
    onClose?.();
  };

  const handleFolder = () => {
    onUploadFolder?.();
    onClose?.();
  };

  return (
    <Dropdown>
      <Item onClick={handleFiles}>Upload Files</Item>

      <Item onClick={handleFolder}>Upload Folder</Item>
    </Dropdown>
  );
};

export default UploadDropdown;
